{ useCallback, useMemo, useRef, useState } = React
{ useI18n } = require 'lib/react_utils'
{ isImmutable } = require 'lib/immutable_utils'
{ rawContentToHTML } = require 'lib/draft_utils'
{ resetSelection } = require 'lib/epiditor_utils'
insertExtension =
  require 'components/document_sections/v2/editor_extensions/insert/insert'
{
  default: EpiEpiditor
  resetState: resetEditorState
  createControlExtension
  serializeState: serializeEditorState
} = Epiditor

isDraft = (content) -> content and content.has and content.has('blocks') and content.has('entityMap')

getJSEditorState = (immEditorState) -> immEditorState.toJS()

getEditorContent = (content) ->
  if isImmutable(content)
    if isDraft(content)
      rawContentToHTML(content)
    else
      getJSEditorState(content)
  else
    content

EpiditorWrapper = ({
  content
  pluginProps
  readOnly
  onCancel
  onSave
}) ->
  i18n = useI18n()

  [editing, setEditing] = useState(false)

  editorContainerRef = useRef(null)

  editMode = if editing then 'edit' else 'readonly'

  handleEditorSave = useCallback(
    (view) ->
      resetSelection view
      onSave?(serializeEditorState(view.state), view)
      setEditing false
    [onSave]
  )

  handleEditorCancel = useCallback(
    (view) ->
      resetEditorState(view, getEditorContent(content))
      onCancel?(view)
      setEditing false
    [content, onCancel]
  )

  handleEditorClick = useCallback(
    ->
      return if editing
      setEditing true unless readOnly
    [editing, readOnly]
  )

  handleReadonlyAttrsUpdate = useCallback(
    (view) ->
      return if editing
      onSave?(serializeEditorState(view.state), view)
    [editing, onSave]
  )

  editorExtensions = useMemo(
    ->
      applyCancelControlsExt = createControlExtension 'applyCancelControlsExt', ({ view }) ->
        <div className="apply-cancel-editor-controls">
          <button className="cancel-btn" onClick={() => handleEditorCancel(view)}>
            {i18n '/actions:cancel'}
          </button>
          <button className="apply-btn" onClick={() => handleEditorSave(view)}>
            {i18n '/actions:save'}
          </button>
        </div>

      [
        applyCancelControlsExt
        insertExtension false,
          gdtTableOptions:
            onReadonlyAttrsUpdate: handleReadonlyAttrsUpdate
      ]
    [handleEditorCancel, handleEditorSave, handleReadonlyAttrsUpdate, i18n]
  )

  <div ref={editorContainerRef}>
    <EpiEpiditor
      extensions={editorExtensions}
      initialState={getEditorContent(content)}
      mode={editMode}
      onClick={handleEditorClick}
      pluginProps={pluginProps}
      parentOverflowContainer={editorContainerRef.current}
    />
  </div>

EpiditorWrapper.propTypes = {
  content: PropTypes.oneOfType([
    PropTypes.object
    PropTypes.string
  ])
  pluginProps: PropTypes.oneOfType([
    PropTypes.array
    PropTypes.object
  ])
  readOnly: PropTypes.bool
  onCancel: PropTypes.func
  onSave: PropTypes.func
}

EpiditorWrapper.defaultProps = {
  content: null
  pluginProps: []
  readOnly: false
  onCancel: null
  onSave: null
}

module.exports = EpiditorWrapper
